@if (!dayIsClosed && (team?.type === 'default' || !team)) {
  <a
    sb-icon-button
    *permission="['Create timesheets', 'Create own timesheet']; user: employeeId; department: team?.department_id"
    [color]="'transparent'"
    [routerLink]="['', { outlets: { modal: ['timesheet', modalData] } }]"
    [attr.aria-label]="'Add' | translate"
  >
    <sb-icon name="add-regular" />
  </a>
}
